import type * as toast from '@zag-js/toast';
import { createContext, useContext } from 'react';

// 2. Create the toast context
const ToastContext = createContext<toast.Store>({} as toast.Store);
const useToast = () => useContext(ToastContext);

export { ToastContext, useToast };
